import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'mode-bin-settings-quick-charts',
  templateUrl: './bin-settings-quick-charts.component.html',
  styleUrls: ['./bin-settings-quick-charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BinSettingsQuickChartsComponent implements OnChanges {
  @Input() binSize: number | undefined;
  @Input() suggestedBinSize?: string | undefined;
  @Input() isLoading!: boolean;
  @Input() disableUseRecommended!: boolean;
  @Input() showRecommendedBinSize = false;

  @Output() binningDetails = new EventEmitter<{ binSize: number; useRecommended: boolean }>();
  binSizeControl = new UntypedFormControl('', [Validators.required]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.binSize) {
      this.binSize ? this.binSizeControl.setValue(this.binSize) : this.binSizeControl.reset();
    }
  }

  handleInputChange(keyCode: number, count: number, isBlur: boolean) {
    if (this.binSizeControl.value > 0) {
      this.binSizeControl.setErrors(null);
    } else {
      this.binSizeControl.setErrors({ inValid: true });
      return;
    }
    if ((keyCode === 13 || isBlur) && this.binSize !== this.binSizeControl.value) {
      this.binSize = this.binSizeControl.value;
      this.binningDetails.emit({
        binSize: this.binSizeControl.value,
        useRecommended: false,
      });
      this.disableUseRecommended = false;
    }
  }

  useRecommendedBinSize() {
    if (this.disableUseRecommended) {
      return;
    }
    this.binningDetails.emit({
      binSize: this.binSizeControl.value,
      useRecommended: true,
    });
    this.disableUseRecommended = true;
  }
}
